<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <AlertForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import AlertForm from '@/components/settings/stock-registers/alerts/AlertForm'

export default {
  name: 'AlertAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    AlertForm
  }
}
</script>